import React from "react";
import "./WhatsAppWidget.css";

const WhatsAppWidget = () => {
  const phoneNumber = "918799841233"; // country code + number (no +)
  const message = "Hello, I need more information.";

  const openWhatsApp = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="whatsapp-float" onClick={openWhatsApp}>
      <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" />
    </div>
  );
};

export default WhatsAppWidget;
